import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class DictionaryCreateViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);


  async canActivate(): Promise<boolean> {
    return await this.routeGuardService.handleRoute(this.getView());
  }
  getView(): View {
    return {
      route: 'dictionary',
      iframeUrl: 'dictionary',
    };
  }
}
